export enum MatomoCategory {
	AUTHENTICATION = "AUTHENTICATION",
	MESSAGES = "MESSAGES",
	TRACK_HEALTH = "TRACK_HEALTH",
	APPOINTMENTS = "APPOINTMENTS",
	HEALTH_REPORT = "HEALTH_REPORT",
}

export enum MatomoAction {
	// Category: AUTHENTICATION
	LOGIN = "LOGIN",
	LOGOUT = "LOGOUT",
	// Category: MESSAGES
	MESSAGE_TAB = "MESSAGE_TAB",
	MESSAGE_SENT = "MESSAGE_SENT",
	// Category: TRACK_HEALTH
	TRACK_HEALTH_TAB = "TRACK_HEALTH_TAB",
	// Category: APPOINTMENTS
	APPOINTMENTS_TAB = "APPOINTMENTS_TAB",
	APPOINTMENTS_UPCOMING = "APPOINTMENTS_UPCOMING",
	APPOINTMENTS_COMLETED = "APPOINTMENTS_COMLETED",
	APPOINTMENTS_BOOKING = "APPOINTMENTS_BOOKING",
	// Category: HEALTH_REPORT
	HEALTH_REPORT_TAB = "HEALTH_REPORT_TAB",
	HEALTH_REPORT_VIEW_NOW = "HEALTH_REPORT_VIEW_NOW",
	HEALTH_REPORT_EMAIL_ME = "HEALTH_REPORT_EMAIL_ME",
	HEALTH_REPORT_RANGE_DAYS7 = "HEALTH_REPORT_RANGE_DAYS7",
	HEALTH_REPORT_RANGE_DAYS30 = "HEALTH_REPORT_RANGE_DAYS30",
	HEALTH_REPORT_RANGE_DAYS90 = "HEALTH_REPORT_RANGE_DAYS90",
	HEALTH_REPORT_RANGE_MONTHS12 = "HEALTH_REPORT_RANGE_MONTHS12",
	HEALTH_REPORT_RANGE_ALL_TIME = "HEALTH_REPORT_RANGE_ALL_TIME",
}

export type MatomoEvent = {
	category: MatomoCategory | string;
	action: MatomoAction | string;
};
